import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from 'axios';

const PlayPattern = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('segmentElevator'); // Replace with your actual endpoint
                setData(response.data.data);
                console.log(data);
            } catch (error) {
                console.error('Error fetching data', error);
            }
        };

        fetchData();
    }, []);

    return (
        <ResponsiveContainer width="100%" height={400}>
            <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="msisdn" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="Wins" fill="#8884d8" />
                <Bar dataKey="MissLog" fill="#82ca9d" />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default PlayPattern;